import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { get_pedidos } from '../../../redux/actions/pedidos'; 
import { Link } from 'react-router-dom';
import eyeblue from '../../../images/eyeblue.svg';
import RequestItemsModal from '../RequestItemsModal'; 
import { MdDelete, MdEdit, MdOutlineInsertComment } from "react-icons/md";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import { BsDashLg } from "react-icons/bs";
import { ImBlocked } from "react-icons/im";
import Overlay from '../../ui/Overlay'; 
import Paginator from '../../ui/Paginator';
import Portal from '../../ui/Portal';
import RequestChecklist from '../RequestChecklist';
import styles from './RequestList.module.css';
import actions from '../../../styles/shared/RequestActions.module.css';
import { formatShortDate } from '../../../utils/date';
import RequestCards from '../RequestCards';
import RequestFiltersPanel from '../RequestFiltersPanel';
import { ESTADOS } from '../requestStates';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { MEDIA } from '../../../styles/breakpoints';

const RequestList = ({ pedidos, get_pedidos, cantidadPaginas}) => {
  const [mostrarComponente, setMostrarComponente] = useState(false);
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [showCheckList, setShowCheckList] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayMessage, setOverlayMessage] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState({
    pageSize: 25,
    page: 1,
    estado: 'undefined',
    nroSolicitud: '',
    fechaCreacion: '',
    fechaResolucion: '',
    fechaCreacionDate: '',
    estadoOrder: 'undefined',
    fechaCreacionOrder: 'undefined',
    fechaCreacionDateOrder: 'desc',
    fechaResolucionOrder: 'undefined',
  });
  // Móvil y tablet portrait: tarjetas + panel de filtros en vez de la tabla.
  const isCompact = useMediaQuery(MEDIA.tabletPortraitDown);
  const handleFiltersChange = (patch) => {
    setSelectedFilters(prevFilters => ({ ...prevFilters, ...patch }));
  };
  // .page es el contenedor con scroll (no la ventana): "Ir arriba" del Paginator lo sube a él.
  const pageRef = useRef(null);
  const scrollToTop = () => pageRef.current?.scrollTo({ top: 0, behavior: 'smooth' });

  const handleNroSolicitudChange = (e) => {
    const value = e.target.value;
    setSelectedFilters({ ...selectedFilters, nroSolicitud: value });
  }

  const handleOverlay = (message, confirmation = false) => {
    setOverlayMessage(message);
    setShowConfirmation(confirmation);
    setShowOverlay(true);
  };
  const handleShowItems = (pedido) => {
    setSelectedPedido(pedido);
    setMostrarComponente(true);
  };

  const handleShowCheckList = (pedido) => {
    setSelectedPedido(pedido);
    setShowCheckList(true);
  };
  const handleConfirmCancel = () => {
    setShowOverlay(false);
  };

  useEffect(() => {
    get_pedidos(selectedFilters);
  }, [get_pedidos, selectedFilters]);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem('idPedido');
    sessionStorage.removeItem('descripcionTaller')
    sessionStorage.removeItem('selectedTaller');
    get_pedidos(selectedFilters)
      .then(() => setLoading(false))
      .catch(error => setLoading(false));
  }, [get_pedidos, selectedFilters]);

  // Botones con ícono (ver styles/shared/RequestActions.module.css). Los mensajes no cambian.
  const commentButton = (message) => (
    <button type="button" className={actions.iconButton} title="Ver comentario" aria-label="Ver comentario" onClick={() => handleOverlay(message)}>
      <MdOutlineInsertComment size={22} />
    </button>
  );
  const cancelButton = (message) => (
    <button type="button" className={`${actions.iconButton} ${actions.danger}`} title="Cancelar solicitud" aria-label="Cancelar solicitud" onClick={() => handleOverlay(message, true)}>
      <MdDelete size={22} />
    </button>
  );

  const obtenerAccion = (estado, idPedido, descripcion) => {
    switch (estado) {
      case 'Recibida':
        return (
          <div className={actions.group}>
            <Link to={`/request/${idPedido}`} className={actions.iconButton} title="Editar solicitud" aria-label="Editar solicitud">
              <MdEdit size={22} />
            </Link>
            {cancelButton('¿Desea cancelar esta solicitud?')}
          </div>
        );
      case 'Rechazado':
        return <div className={actions.group}>{commentButton(`Solicitud rechazada por administrador ${descripcion}`)}</div>;
      case 'En proceso':
        return <div className={actions.group}>{cancelButton(`¿Desea cancelar esta solicitud? ${descripcion}`)}</div>;
      case 'Entregado':
        return <div className={actions.group}>{commentButton(`Entregado ${descripcion}`)}</div>;
      case 'Finalizado':
        return <div className={actions.group}>{commentButton(`Finalizado ${descripcion}`)}</div>;
      case 'Listo para retiro':
        return <div className={actions.group}>{commentButton(`Listo para retiro ${descripcion}`)}</div>;
      default:
        return (
          <div className={actions.group}>
            <div className={actions.disabledIcon} title="Sin acciones disponibles">
              <ImBlocked size={20} />
            </div>
          </div>
        );
    }
  };

  const handlePageSize = (e) => {
    const value = parseInt(e.target.value, 10);
    setSelectedFilters({ ...selectedFilters, pageSize: value });
  }

  const handlePageChange = (page) => {
    setSelectedFilters(prevFilters => ({ ...prevFilters, page }));
  };

  const handleStateChange = (e) => {
    const value = e.target.value;
    setSelectedFilters({ ...selectedFilters, estado: value });
  }


  const handleSortChange = (filter) => {
    const order = selectedFilters[filter];
    const newOrder = order === 'undefined' ? 'desc' : order === 'desc' ? 'asc' : 'undefined';
    
    setSelectedFilters(prevFilters => {
      const updatedFilters = {
        ...prevFilters,
        estadoOrder: 'undefined',
        fechaCreacionDateOrder: 'undefined',
        fechaCreacionOrder: 'undefined',
        fechaResolucionOrder: 'undefined',
        [filter]: newOrder
      };
      return updatedFilters;
    });
  };
  return (
    <div className={styles.page} ref={pageRef}>
      <h2>Solicitudes</h2>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <form className={styles.filters}>
            <label>
              Cant. solicitudes:
              <select
                className={styles.filterSelect}
                name="pageSize" 
                id="pageSize" 
                value={selectedFilters.pageSize}
                onChange={handlePageSize} >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
              </select>
            </label>
          </form>
          {isCompact ? (
            <>
              <RequestFiltersPanel filters={selectedFilters} onChange={handleFiltersChange} />
              <RequestCards pedidos={pedidos} onShowItems={handleShowItems} renderAction={(pedido) => obtenerAccion(pedido.estado, pedido.id, pedido.descripcion)} />
            </>
          ) : (
          <div className={styles.tableWrapper}>
            <table className={`${styles.table} ${styles.teacherTable}`}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeadTitles}>
                  <th className={styles.idCol}>
                    <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>ID</span>
                    <input
                      type="text"
                      placeholder="ID"
                      className={styles.filterInput}
                      name="nroSolicitud"
                      id="nroSolicitud"
                      value={selectedFilters.nroSolicitud}
                      onChange={handleNroSolicitudChange}
                    />
                  </th>
                  <th onClick={() => handleSortChange('estadoOrder')} className={`${styles.sortable} ${styles.statusCol}`}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Estado</span>
                      {selectedFilters.estadoOrder === 'undefined' ? <BsDashLg/> : selectedFilters.estadoOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <select
                      className={styles.filterSelect}
                      name="estado" 
                      id="estado" 
                      value={selectedFilters.estado}
                      onClick={(e) => e.stopPropagation()}
                      onChange={handleStateChange} >
                        {Object.keys(ESTADOS).map(key => (
                          <option key={key} value={key === '' ? undefined : key}>
                            {ESTADOS[key]}
                          </option>
                        ))}
                    </select>
                  </th>
                  <th className={styles.itemsCol}>Ítems</th>
                  <th onClick={() => handleSortChange('fechaCreacionDateOrder')} className={`${styles.sortable} ${styles.dateCol}`}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Creación</span>
                      {selectedFilters.fechaCreacionDateOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaCreacionDateOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaCreacionDate"
                      id="fechaCreacionDate"
                      className={styles.filterInput}
                      value={selectedFilters.fechaCreacionDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaCreacionDate: e.target.value });
                      }}
                    />
                  </th>
                  <th onClick={() => handleSortChange('fechaCreacionOrder')} className={`${styles.sortable} ${styles.dateCol}`}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Retiro</span>
                      {selectedFilters.fechaCreacionOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaCreacionOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaCreacion"
                      id="fechaCreacion"
                      className={styles.filterInput}
                      value={selectedFilters.fechaCreacion}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaCreacion: e.target.value });
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </th>
                  <th onClick={() => handleSortChange('fechaResolucionOrder')} className={`${styles.sortable} ${styles.dateCol}`}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Devolución</span>
                      {selectedFilters.fechaResolucionOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaResolucionOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaResolucion"
                      id="fechaResolucion"
                      className={styles.filterInput}
                      value={selectedFilters.fechaResolucion}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaResolucion: e.target.value });
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </th>
                  <th className={styles.actionColIcons}>Acción</th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {pedidos && pedidos.length > 0 && pedidos.map((pedido) => {
                  return (
                    <tr key={pedido.id}>
                      <td>{pedido.id}</td>
                      <td>{pedido.estado}</td>
                      <td>
                        {pedido.items}
                        <button
                          type='button'
                          className={styles.itemsButton}
                          onClick={() => handleShowItems(pedido)}
                          aria-label={`Ver ítems de la solicitud ${pedido.id}`}
                          title='Ver ítems'
                        >
                          <img src={eyeblue} alt='' />
                        </button>
                      </td>
                      <td>{formatShortDate(pedido.pedido_creation_date)}</td>
                      <td>{formatShortDate(pedido.fecha_creacion)}</td>
                      <td>{formatShortDate(pedido.fecha_resolucion)}</td>
                      <td>{obtenerAccion(pedido.estado, pedido.id, pedido.descripcion)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          )}
          <Paginator 
        currentPage={selectedFilters.page} 
        handlePageChange={handlePageChange} 
        totalPageCount={cantidadPaginas} 
        onScrollTop={isCompact ? scrollToTop : undefined}
      />
        </>
      )}
      {/* Modales fuera de .page (clip-path + overflow los recortaban al recuadro de la lista) */}
      <Portal>
       {showOverlay && <Overlay message={overlayMessage} onClose={() => setShowOverlay(false)} showConfirmation={showConfirmation} onConfirm={handleConfirmCancel} />}
       {mostrarComponente && <RequestItemsModal onClose={() => setMostrarComponente(false)} pedido={selectedPedido} handleShowCheckList={handleShowCheckList} escapeDisabled={showCheckList} />}
       {showCheckList && (
        <RequestChecklist
          mostrarCheckList={showCheckList}
          setMostrarCheckList={setShowCheckList}
          solicitud={selectedPedido}
        />
      )}
      </Portal>
    </div>
  );
}

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
  pedidos: state.Pedidos.pedidosUsuario,
  cantidadPaginas: state.Pedidos.totalPaginas
});

export default connect(mapStateToProps, { get_pedidos })(RequestList);
